/**
 * Convert time from '01:30 PM' to '13:30'
 * @param time
 * @returns {string}
 */
export function time12To24HoursFormat(time) {
  const matches = time.match(/^(\d{1,2}):(\d{2}) (AM|PM)$/);
  if (!matches) {
    return '';
  }
  let hours = matches[1] === '12' ? '00' : matches[1];
  const minutes = matches[2];
  const type = matches[3];
  if (type === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }
  hours = `0${hours}`.slice(-2);
  return `${hours}:${minutes}`;
}
